import { useState } from 'react';

import * as Icon from 'react-bootstrap-icons';

import TranslatesComponent from './TranslatesComponent';
import type { Language } from './types';

interface Props {
  languages?: Array<Language>;
  availableLanguages: Array<string>;
  onCreate: (language: Language) => void | Promise<void>;
  onEdit: (language: Language) => void | Promise<void>;
  onRemove?: (language: string) => void | Promise<void>;
  defaultLang?: string;
  displayLabel?: string;
  maxLength?: number;
  keepModalOpenOnChange?: boolean;
  saveAction?: boolean;
}

function TranslatesWrapper({
  languages,
  availableLanguages,
  onCreate,
  onEdit,
  onRemove,
  defaultLang,
  displayLabel,
  maxLength,
  keepModalOpenOnChange = false,
  saveAction = false
}: Props) {
  const [showModalTraslate, setShowModalTraslate] = useState(false);
  const totalLanguages = Math.max(availableLanguages.length - 1, 0);
  const label = displayLabel ?? defaultLang;

  return (
    <>
      <div className="translation-link">
        <a className="small" onClick={() => setShowModalTraslate(true)} role="button">
          {label ? `${label} ` : ''}
          <Icon.GeoAlt /> {languages?.length ?? 0}/{totalLanguages}
        </a>
      </div>

      <TranslatesComponent
        availableLanguages={availableLanguages}
        showModal={showModalTraslate}
        onClose={() => setShowModalTraslate(false)}
        onCreate={async (language) => {
          await onCreate(language);
          if (!keepModalOpenOnChange) {
            setShowModalTraslate(false);
          }
        }}
        onEdit={async (language) => {
          await onEdit(language);
          if (!keepModalOpenOnChange) {
            setShowModalTraslate(false);
          }
        }}
        onRemove={onRemove}
        languages={languages}
        defaultLang={defaultLang}
        maxLength={maxLength}
        keepModalOpenOnChange={keepModalOpenOnChange}
        saveAction={saveAction}
      />
    </>
  );
}

export default TranslatesWrapper;
